import React, { useEffect, useState } from 'react';
import classes from "./style.module.scss";
import { Icons, Images } from '../../assets';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import NotificationDropdown from '../../modalComponents/NotificationDropdown';
import { useNavigate } from 'react-router-dom';

const Navbar = () => {
    const [showNotification, setShowNotification] = useState(false);
    const [currentDateTime, setCurrentDateTime] = useState('');
    const navigate = useNavigate()

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentDateTime(formatDateTime());
        }, 1000); // Update every 1 second

        // Cleanup interval on component unmount
        return () => clearInterval(interval);
    }, []);

    const formatDateTime = () => {
        const now = new Date();

        const options = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true, // Enables 12-hour format with AM/PM
            // timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            timeZone: 'Asia/Dubai'
        };

        const formattedDateTime = new Intl.DateTimeFormat('en-GB', options).format(now);

        // Convert to desired format: DD-MM-YYYY HH:MM:SS AM/PM
        const [date, time] = formattedDateTime.split(', ');
        const [day, month, year] = date.split('/');
        return `${day}-${month}-${year} ${time}`;
    };

    const navigateToProfile = () => {
        navigate(`/admin/profile`)
    }

    return (
        <>
            <div className={`relative ${classes.navWrapper}`}>
                <div className={`${classes.navHeader} w-[100%] flex items-center justify-between`}>
                    <div className={`${classes.appLogoContainer}`}>
                        <img src={Icons.kgLogo} className={`${classes.appLogo}`} />
                    </div>
                    <div className={`${classes.profileContainer} flex items-center`}>
                        <div className={classes.userTimeRange}>{currentDateTime}</div>
                        <div className={`${classes.headerAction} ${classes.notificationBell} flex items-center justify-center`}>
                            <img src={Icons.bellIcon} className={`${classes.appLogo}`} onClick={() => setShowNotification(!showNotification)} />                            
                        </div>
                        <div className={`${classes.headerAction}  ${classes.profileHeader} flex items-center justify-center`}>
                            <AccountCircleIcon onClick={() => navigateToProfile()} />
                        </div>
                    </div>
                </div>
                <div>
                    <img src={Images.colorBar} className={`${classes.colorBar}`} />
                </div>
            </div>
            {showNotification ?
                <NotificationDropdown isOpen={showNotification} closePopUp={setShowNotification} notifymodal />
                : null
            }
        </>
    );
}

export default Navbar